<style scoped>
    ::v-deep .v-pagination__item {
        /* 外部から設定可能にするために継承する（実際に生成されるタグに反映されるようにする） */
        font-size: inherit;
    }
</style>
<template>
        <v-pagination v-model="page" :length="length" :disabled="disabled" :total-visible="totalVisible" :style="{ fontSize: fontSize + 'px', fontWeight: fontWeight,}"></v-pagination>
</template>
<script>
    export default {
        computed: {
            page: {
                get() {
                    return this.value;
                },
                set(value) {
                    // 親コンポーネントへの通知
                    this.$emit('input', value);
                }
            },
        },
        props: {
            value: {
                type: Number,
            },
            // 最大ページ数
            length: {
                type: Number,
            },
            // フォントサイズ
            fontSize: {
                type: String,
                default: "20"
            },
            // フォントの太さ
            fontWeight: {
                type: String,
            },
            // 表示されるページボタンの最大数
            totalVisible: {
                type:Number,  
            },
            // 無効化
            disabled: {
                type:Boolean,
                default: false,
            }
        },
    }
</script>